import "./home.css";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import search from "../../assets/plus-1.png";
import star from "../../assets/plus-3.png";
import setting from "../../assets/plus-2.png";
import a1 from "../../assets/1-a.png";
import a2 from "../../assets/2-a.png";
import a3 from "../../assets/3-a.png";
import { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";

function ScrollDetail({ t }) {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const isTablet = window.matchMedia("(min-width: 778px)").matches;
  const [current, setCurrent] = useState(1);

  useEffect(() => {
    document?.getElementById("scrollDiv")?.addEventListener("scroll", () => {
      setCurrent(
        document?.getElementById("scrollDiv")?.scrollLeft < 110
          ? 1
          : document?.getElementById("scrollDiv")?.scrollLeft < 280
          ? 2
          : 3
      );
    });
  });

  return (
    <div
      style={{
        padding: isDesktopOrLaptop ? 0 : "23px 0px 16px 12px",
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <Grid
        container
        justifyContent={isDesktopOrLaptop || isTablet ? "center" : "flex-start"}
        style={{
          paddingRight: "12px",
        }}
      >
        <h1
          className={
            isDesktopOrLaptop
              ? "Sense-your-market-wi"
              : "Sense-your-market-wi-mobile"
          }
        >
          {t("powerful")}
        </h1>
      </Grid>
      <Grid
        id="scrollDiv"
        style={{
          display: "flex",
          justifyContent:
            isDesktopOrLaptop || isTablet ? "center" : "flex-start",
          overflowX: "scroll",
          maxWidth: isDesktopOrLaptop || isTablet ? "100%" : "95vw",
          width: "100%",
          height: "350px",
        }}
        className="invisible-scrollbar"
      >
        <div
          className={
            isDesktopOrLaptop ? "Blue-rectangle" : "Blue-rectangle-mobile"
          }
          style={{ marginLeft: "0px" }}
        >
          <div
            style={{
              padding: isDesktopOrLaptop
                ? "20px 32.5px 22px 18px"
                : "23.6px 12px 22px 13px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "Center",
              }}
            >
              <img
                src={search}
                alt="search"
                className="RectangleImage"
                style={{
                  width: isDesktopOrLaptop ? "" : "177px",
                  height: isDesktopOrLaptop ? "165px" : "177px",
                  margin: isDesktopOrLaptop ? "" : 0,
                }}
              ></img>
            </div>
            <p className="Cerca-strumenti-fina">{t("natural")}</p>
          </div>
        </div>
        <div
          className={
            isDesktopOrLaptop ? "Blue-rectangle" : "Blue-rectangle-mobile"
          }
        >
          <div
            style={{
              padding: isDesktopOrLaptop
                ? "20px 32.5px 22px 18px"
                : "23.6px 12px 22px 13px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "Center",
              }}
            >
              <img
                src={setting}
                alt="setting"
                className="RectangleImage"
                style={{
                  width: isDesktopOrLaptop ? "" : "177px",
                  height: isDesktopOrLaptop ? "165px" : "177px",
                  margin: isDesktopOrLaptop ? "" : 0,
                }}
              ></img>{" "}
            </div>
            <p className="Cerca-strumenti-fina">{t("browse")}</p>
          </div>
        </div>
        <div
          className={
            isDesktopOrLaptop ? "Blue-rectangle" : "Blue-rectangle-mobile"
          }
          style={{
            marginRight: 0,
          }}
        >
          <div
            style={{
              padding: isDesktopOrLaptop
                ? "20px 0px 22px 18px"
                : "23.6px 12px 22px 13px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "Center",
              }}
            >
              <img
                src={star}
                alt="star"
                className="RectangleImage"
                style={{
                  width: isDesktopOrLaptop ? "" : "177px",
                  height: isDesktopOrLaptop ? "165px" : "177px",
                  margin: isDesktopOrLaptop ? "" : 0,
                }}
              ></img>{" "}
            </div>
            <p className="Cerca-strumenti-fina">{t("stocks")}</p>
          </div>
        </div>
      </Grid>
      {isDesktopOrLaptop ? null : (
        <Grid
          container
          style={{
            paddingTop: "10px",
            paddingBottom: "15px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              margin: "0 7px 0 0",
              border: "solid 1px #16063b",
              borderRadius: "50%",
              backgroundColor: current === 1 ? "#16063b" : "",
              cursor: "pointer",
            }}
            onClick={() => {
              if (document?.getElementById("scrollDiv")) {
                document.getElementById("scrollDiv").scrollLeft = 0;
                setCurrent(1);
              }
            }}
          />
          <div
            style={{
              width: "10px",
              height: "10px",
              margin: "0 7px",
              border: "solid 1px #16063b",
              borderRadius: "50%",
              backgroundColor: current === 2 ? "#16063b" : "",
              cursor: "pointer",
            }}
            onClick={() => {
              if (document?.getElementById("scrollDiv")) {
                document.getElementById("scrollDiv").scrollLeft = 160;
                setCurrent(2);
              }
            }}
          />
          <div
            style={{
              width: "10px",
              height: "10px",
              margin: "0 0 0 7px",
              border: "solid 1px #16063b",
              borderRadius: "50%",
              backgroundColor: current === 3 ? "#16063b" : "",
              cursor: "pointer",
            }}
            onClick={() => {
              if (document?.getElementById("scrollDiv")) {
                document.getElementById("scrollDiv").scrollLeft = 360;
                setCurrent(3);
              }
            }}
          />
        </Grid>
      )}
      {isDesktopOrLaptop ? (
        <>
          <Grid container alignItems="center">
            <Grid item xs={7}>
              <img
                src={a1}
                alt="A1"
                className="A"
                style={{
                  margin: "41px 593.7px 0 0",
                }}
              ></img>
            </Grid>
            <Grid item xs={5}>
              <p
                className="Cerca-strumenti"
                style={{ margin: "0 68px 27px 0" }}
              >
                {t("home_t1")}
              </p>
              <p
                className="Lorem-ipsum-dolor-si"
                style={{ margin: "27px 60px 0 4px" }}
              >
                {t("home_p11")} <br />• {t("home_p12")} <br />• {t("home_p13")}{" "}
                <br />• {t("home_p14")} <br />• {t("home_p15")} <br />•{" "}
                {t("home_p16")}
              </p>
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid item xs={5}>
              <p
                className="Cerca-strumenti"
                style={{ margin: "0 0px 25px 100px" }}
              >
                {t("home_t2")}
              </p>
              <p
                className="Lorem-ipsum-dolor-si"
                style={{ margin: "0px 0 0 100px" }}
              >
                {t("home_p21")}
              </p>
            </Grid>
            <Grid
              item
              xs={7}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={a2}
                alt="A1"
                style={{ objectFit: "contain", margin: "0px 0 0 614px" }}
              ></img>
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            style={{
              paddingBottom: "25px",
            }}
          >
            <Grid item xs={7}>
              <img
                src={a3}
                alt="A3"
                className="A"
                style={{ margin: "0px 0px 1px 0px" }}
              ></img>
            </Grid>
            <Grid item xs={5}>
              <p
                className="Cerca-strumenti"
                style={{ margin: "0 60px 26px 0px" }}
              >
                {t("home_t3")}
              </p>
              <p
                className="Lorem-ipsum-dolor-si"
                style={{ margin: "26px 60px 0 0px" }}
              >
                {t("home_p31")} <br />
                {t("home_p32")}
                <br />
                {t("home_p33")}
                <br />
                {t("home_p34")} <br />
                {t("home_p35")}
                <br />
                {t("home_p36")}
                <br />
              </p>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid container alignItems="center" style={{ paddingRight: "12px" }}>
            <Grid item xs={12}>
              <img
                src={a1}
                alt="A1"
                className="A"
                style={{
                  width: "100%",
                }}
              ></img>
            </Grid>
            <Grid item xs={12}>
              <p
                className="Cerca-strumenti-mobile"
                style={{ margin: "0 0px 27px 0" }}
              >
                {t("home_t1")}
              </p>
              <p
                className="Lorem-ipsum-dolor-si"
                style={{ margin: "27px 0 0 4px" }}
              >
                {t("home_p11")} <br />• {t("home_p12")}
                <br />• {t("home_p13")}
                <br />• {t("home_p14")}
                data) <br />• {t("home_p15")}
              </p>
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <img
                src={a2}
                alt="A2"
                className="A"
                style={{
                  margin: "21.8px 0 18px",
                  width: "100%",
                }}
              ></img>
            </Grid>
            <Grid item xs={12}>
              <p
                className="Cerca-strumenti-mobile"
                style={{ margin: "0 8px 27px 0" }}
              >
                {t("home_t2")}
              </p>
              <p
                className="Lorem-ipsum-dolor-si"
                style={{ margin: "27px 0 0 4px" }}
              >
                {t("home_p21")}
              </p>
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <img
                src={a3}
                alt="A3"
                className="A"
                style={{
                  margin: "21.8px 0 18px",
                  width: "100%",
                }}
              ></img>
            </Grid>
            <Grid item xs={12}>
              <p
                className="Cerca-strumenti-mobile"
                style={{ margin: "0 8px 27px 0" }}
              >
                {t("home_t3")}
              </p>
              <p
                className="Lorem-ipsum-dolor-si"
                style={{ margin: "27px 0 0 4px" }}
              >
                {t("home_p31")} <br />
                {t("home_p32")}
                <br />
                {t("home_p33")}
                <br />
                {t("home_p34")} <br />
                {t("home_p35")}
                <br />
                {t("home_p36")}
                <br />
              </p>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}

export default withNamespaces()(ScrollDetail);
